export const REG_EX = {
  ADDRESS: /^0x[0-9a-fA-F]{40}$/i,
  EMAIL: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
  DECIMAL: /^\d*([.,]\d*)?$/i,
}
